import { nav }    from "@/theme";
import { chakra } from "@chakra-ui/react";

export const NavBar = chakra("nav", nav);